import PropTypes from 'prop-types';

import { Link as LibraryLink } from '@spotahome/ui-library';

import './Link.scss';

const Link = ({ children, ...rest }) => {
  return <LibraryLink {...rest}> {children}</LibraryLink>;
};

Link.propTypes = {
  children: PropTypes.node.isRequired
};

export default Link;
